// Stub constants for Fuul referrals program
export const FUUL_REFERRALS_REWARDS_CONFIG = {
  rebatePercentage: 10,
  tierCommissionPercentages: {
    tierOne: 10,
    tierTwo: 15,
    tierThree: 20,
    tierFour: 25,
    tierFive: 30,
  },
} as const;
